// const dev = {
//   API_ENDPOINT_URL: "https://econtract-zuellig-dev.lcssoft.com.vn/api",
// };
//
// const prod = {
//   API_ENDPOINT_URL: "https://econtract-zuellig-dev.lcssoft.com.vn/api",
// };
//
// const test = {
//   API_ENDPOINT_URL: "https://econtract-zuellig-dev.lcssoft.com.vn/api",
// };

require("dotenv").config();
const API_ENDPOINT_URL = process.env.REACT_APP_DEFAULTAUTH;
const API_MSP = process.env.REACT_APP_API_MSP;
const API_MSC = process.env.REACT_APP_API_MSC;
const API_MSCSM = process.env.REACT_APP_API_MSCSM;
const API_APPCODE = process.env.REACT_APP_API_APP_CODE;
const API_AIR_BRAKE_ENV = process.env.REACT_APP_AIR_BRAKE_ENV;
const API_MSPCNM = process.env.REACT_APP_API_MSPCNM;

const getEnv = () => {
  // switch (process.env.NODE_ENV) {
  //   case "development":
  //     return dev;
  //   case "production":
  //     return prod;
  //   case "test":
  //     return test;
  //   default:
  //     break;
  // }
  return {
    API_ENDPOINT_URL,
    API_MSP,
    API_MSC,
    API_MSCSM,
    API_APPCODE,
    API_AIR_BRAKE_ENV,
    API_MSPCNM,
  };
};

export const env = getEnv();
